import {EmailInputView} from "./EmailInputView.js";
import {GoogleButton} from "../components/button/GoogleButton.js";
import {KakaoButton} from "../components/button/KakaoButton.js";
import {AppleButton} from "../components/button/AppleButton.js";
import {SnsButtonsLayout} from "../components/layout/SnsButtonsLayout.js";

export class GuestEmailView extends EmailInputView {

    renderLayout() {
        const { mainText = '', subText = ''} = this.$props;
        new SnsButtonsLayout(this.$target, {
            isAppend: true,
            sectionId : this.getSectionId(),
            mainText,
            subText,
            nextButton: {
                text: this.getNextButtonText(),
                nextPageFunc: this.moveEmailAuthView.bind(this)
            }
        });
    }

    renderComponents() {
        super.renderComponents();
        this.renderSnsButtons();
    }

    renderSnsButtons() {
        const $section = $(`#${this.getSectionId()}`);
        const SnsButtonLayers = $section.find(".js-sns-button-wrap");
        new GoogleButton(SnsButtonLayers, {
            type: "a",
            isAppend: true,
        })
        new KakaoButton(SnsButtonLayers, {
            type: "a",
            isAppend: true,
        })
        new AppleButton(SnsButtonLayers, {
            type: "a",
            isAppend: true,
        })
    }
}